module.exports = __webpack_public_path__ + "static/media/ic-thumbnail.ba9f0c2d.svg";